import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Portal, svgSprite } from '../../../hybrid/wrappers';
import { dataSender, getData } from '../../../common/utils/router';
import UserContext, { UserProfileContext } from '../../../common/utils/getContext';
import { API_SERVER_URL, useWidgetTranslates } from '../../../common/utils/utils';
import { t } from '../../../common/components/T';
import { LangContext } from '../../../common/decorators/Language';
import moment from 'moment/moment';
import Timer from '../Timer';
import PropTypes from 'prop-types';
import FormInput from '../../form/components/form-input/FormInput/FormInput';
import css from './modal2FA.module.scss';
import classNames from 'classnames';
import SingleButton from '../../form/form-control-buttons/SingleButton/SingleButton';

const Modal2FA = ({
    info,
    sendData = {},
    transl,
    time,
    senderFunc,
    reSender,
    closeHandler,
    notSendCode,
    securityType,
    typeList
}) => {
    const { type } = sendData;
    const [codeInput, setCodeInput] = useState('');
    const [errors, setError] = useState([]);
    const { translation } = useContext(LangContext) || {};
    const { setAlertData } = useContext(UserContext) || {};

    useEffect(() => {
        return () => {
            setCodeInput('');
        };
    }, [type]);

    return (
        <Portal closeHandler={closeHandler}>
            <div className={css.modalWrapper}>
                <div className={classNames('circleButton grow', css.closeWrap)} onClick={closeHandler}>
                    {svgSprite('cross', {
                        className: css.modalWindowCloseIcon,
                        fill: 'var(--greyExtraDarkColor)'
                    })}
                </div>
                <div className={css.modalTitle}>
                    {t('2fa_modal-Title-new', 'Двухэтапная аутентификация', 'widget', transl, 'modal2FA')}
                </div>
                <div className={css.modalUnderTitle}>
                    {t(
                        '2fa_modal-UnderTitle',
                        'Введите код двухэтапной аутентификации для безопасности',
                        'widget',
                        transl,
                        'modal2FA'
                    )}
                </div>
                {info ? <div className={css.modalInfo}>{info}</div> : null}
                {!notSendCode && (
                    <div className={css.timeWrapper}>
                        {time ? (
                            <>
                                <div className={css.timeText}>
                                    {t(
                                        '2fa_modal-LifeSicle-new',
                                        'Срок действия кода закончится через',
                                        'widget',
                                        transl,
                                        'modal2FA'
                                    )}
                                    :
                                </div>
                                <Timer translation={transl} styles={{ ...css }} date={time} />
                            </>
                        ) : notSendCode ? null : (
                            <>
                                <div className={css.timeText}>
                                    {t(
                                        '2fa_modal-LifeSicle-new',
                                        'Срок действия кода закончится через',
                                        'widget',
                                        transl,
                                        'modal2FA'
                                    )}
                                    :
                                </div>
                                <div className={css.blockTime}>{`-- : --`}</div>
                            </>
                        )}
                    </div>
                )}
                <div className={css.middleWrapper}>
                    <div className={classNames(css.inputWraper, css.inputWraper_full)}>
                        <FormInput
                            title={{
                                body:
                                    securityType?.name === 'email'
                                        ? t('2fa_modal-fromEmail', 'Код из письма на Email', 'widget', transl, 'modal2FA')
                                        : typeList?.length
                                        ? t('2fa_modal-from-empty', 'Код из', 'widget', transl, 'modal2FA') +
                                          ` ${
                                              typeList.find((el) => el.name === securityType?.name)?.name_translated ||
                                              securityType?.name
                                          }`
                                        : t('phone_modal-CodeFromApp', 'Введите полученный код', 'widget', transl, 'modal2FA')
                            }}
                            errors={errors}
                            compStyle={{}}
                            placeholder={'****'}
                            value={codeInput}
                            setFormData={(a, v) => {
                                setCodeInput(v);
                            }}
                            info={t('2fa_modal-input-hint', 'Введите код из письма или приложения', 'widget', transl, 'modal2FA')}
                        />
                    </div>
                </div>
                <div className={css.buttons}>
                    {!notSendCode || 1 ? (
                        <SingleButton
                            customButton={{
                                singleButton: css.modalBtn
                            }}
                            type='cancel'
                            buttonText={t('2fa_modal-send-again', 'Отправить код еще раз', 'widget', transl, 'modal2FA')}
                            clickFunc={() => {
                                setCodeInput('');
                                setError([]);
                                reSender();
                            }}
                        />
                    ) : null}
                    <SingleButton
                        customButton={{
                            singleButton: css.modalBtn
                        }}
                        disabled={!codeInput.length}
                        type='ok'
                        buttonText={t('confirm', 'Подтвердить', 'all', translation)}
                        clickFunc={() => {
                            const onError = (e) => {
                                setAlertData({
                                    type: 'error',
                                    cont: e
                                });
                                setError(e);
                            };
                            try {
                                senderFunc(codeInput)
                                    .then(() => closeHandler())
                                    .catch(onError);
                            } catch (e) {
                                onError(e);
                            }
                        }}
                    />
                </div>
            </div>
        </Portal>
    );
};
export const useModal2FA = (sendData, senderFunc, closeHandler, customData, securityType, typeList) => {
    const { url, info, sendCode } = customData || {};
    const [showModal, setShowModal] = useState(false);
    const { setAlertData, userToken, lang } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext) || {};

    const { type, event } = sendData;
    const [time, setTime] = useState(false);
    const [notSendCode, setNotSendCode] = useState(Boolean(!sendCode));

    const [typeListData, setTypeListData] = useState(typeList);
    const [securityTypeData, setSecurityTypeData] = useState(securityType);

    useEffect(() => {
        (async () => {
            if (userToken) {
                if (!typeListData) {
                    const resTypeList = await getData('/api/v1/user/security/type-list', userToken, lang);
                    setTypeListData(resTypeList?.data);
                }

                if (!securityType) {
                    const verefyStatus = await getData('/api/v1/user/security', userToken, lang);
                    setSecurityTypeData(verefyStatus?.data?.security_type);
                }
            }
        })();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [lang, userToken]);

    const transl = useWidgetTranslates('modal2FA');
    const reSender = useCallback(
        (data) => {
            setTime(false);
            const { login, password } = data || sendData;
            return new Promise((resolve, reject) =>
                dataSender(
                    url || `${API_SERVER_URL}/api/v1/user/security/send-code`,
                    'POST',
                    {
                        login,
                        password,
                        event,
                        type
                    },
                    () => {
                        setAlertData({
                            type: 'success',
                            cont: t('2fa_send-code', 'Код отправлен', 'widget', transl, 'modal2FA')
                        });
                        setTime(moment(new Date()).add(10, 'minutes').format('MM/DD/YYYY HH:mm:ss'));
                        resolve();
                    },
                    () => {
                        setAlertData({
                            type: 'error',
                            cont: t('2fa_Error-send-code', 'Ошибка при отправке кода', 'widget', transl, 'modal2FA')
                        });
                        reject(new Error('send-code error'));
                    },
                    userToken,
                    lang
                )
            );
        },
        [event, sendData, transl, url, lang, setAlertData, type, userToken]
    );

    const closeHandlerFunc = () => {
        closeHandler && closeHandler();
        setShowModal(false);
    };
    const func2Fa = useCallback(
        async (data) => {
            if (type === 'google') {
                setTime(moment(new Date()).add(10, 'minutes').format('MM/DD/YYYY HH:mm:ss'));
                setShowModal(true);
            } else if (sendCode) {
                reSender(data).finally(() => {
                    setShowModal(true);
                });
            } else {
                const settings = await getData(`/api/v1/user/security/${data?.login || profileData?.username}/settings`);
                setNotSendCode(!settings?.data?.need_to_send_code);
                if (settings?.data?.need_to_send_code) {
                    reSender(data).then(() => {
                        setShowModal(true);
                    });
                } else {
                    setShowModal(true);
                }
            }
        },
        [profileData?.username, reSender, sendCode, type]
    );

    return {
        func2Fa,
        Modal2FA: showModal ? (
            <Modal2FA
                {...{
                    info,
                    sendData,
                    transl,
                    time,
                    senderFunc,
                    reSender,
                    closeHandler: closeHandlerFunc,
                    notSendCode,
                    securityType: securityTypeData,
                    typeList: typeListData
                }}
            />
        ) : null
    };
};
Modal2FA.propTypes = {
    type: PropTypes.string,
    event: PropTypes.string,
    sendData: PropTypes.object,
    senderFunc: PropTypes.func,
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    ifClosed: PropTypes.func
};
export default Modal2FA;
